<template>
    <div>
        <div class="title">{{this.$t('ordine_n_persone')}}</div>
        <options-carousel
            :entries="this.people_entries"
            @onSnapToItem="this.onPeopleSnapToItem"
        />
        <div class="title">{{$t('ordine_scelta_data_titolo')}}</div>
        <options-carousel
            :entries="this.days_entries"
            @onSnapToItem="this.onDaysSnapToItem"
        />
        <div class="title">{{$t('ordine_scelta_orario_titolo')}}</div>
        <options-carousel
            ref="times_carousel"
            :entries="this.times_entries"
            @onSnapToItem="this.onTimeSnapToItem"
        />


        <div class="title">{{$t('prenotazione_tavolo.dati')}}</div>
        <div class="container">
            <div class="row row-sezione">
                <div class="col-md-6">
                    <div class="form-group">
                        <input type="text" class="form-control" v-model="name"
                               :placeholder="$t('nome')+' *'">
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <input type="text" class="form-control" v-model="phone"
                               :placeholder="$t('telefono')+' *'">
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <input type="text" class="form-control" v-model="email"
                               :placeholder="$t('email')+' *'">
                    </div>
                </div>
                <div class="col-12">
                    <div class="form-group">
                                <textarea class="form-control" rows="3" v-model="note"
                                          :placeholder="$t('note')"></textarea>
                    </div>
                </div>
                <div class="col-12" v-if="this.fAcconto">
                    <div class="form-group">
                        <select class="form-control" v-model="id_acconto">
                            <option value="">{{$t("seleziona_acconto")}}</option>
                            <option v-for="item in this.acconti" :value="item.id">
                                {{item.prezzo.toFixedGood(2)}} {{locale_currency}}
                            </option>
                        </select>
                    </div>
                </div>

                <!-- X STE la colonna dei metodi di pagamento compare solo dopo aver selezionato l'acconto -->
                <div class="col-12" v-if="!!this.id_acconto">
                    <inc-payment-mode :reservation-mode="true"
                                      :items="this.payment_modes"
                                      :value="this.payment_mode ? this.payment_mode.id : null"
                                      @onItemPress="this.onPaymenModePress"
                                      @onNewCardPress="this.onNewCardPress"
                                      @onDeletePress="this.onCardDeletePress"
                    />
                </div>
                <div class="col-md-6 text-left" v-for="checkbox in this.privacyCheckboxes">
                    <mcw-checkbox @change="onPrivacyCheck(checkbox)" :checked="privacy_obj[checkbox.db_name] === 1">
                        {{checkbox.label}}
                        <a v-if="!!checkbox.url" href="#" class="a3" @click.prevent="openPrivacyModal(checkbox)">
                            <i>{{$t('news.leggi')}} »</i>
                        </a>
                    </mcw-checkbox>
                </div>
            </div>
        </div>
        <hr>
        <div class="row-sezione">
            <button type="button" class="btn btn-menu" :disabled="this.loading_visible" @click="onReserveTap">
                {{$t('prenotazione_tavolo.submit_btn')}}
            </button>
        </div>

        <modal-stripe-payment v-if="this.show_stripe_payment_modal"
                              :stripe="this.stripe"
                              :save="this.stripe_payment_modal_save"
                              :hide-save-card="!(this.user && this.user.api_key)"
                              @close="show_stripe_payment_modal = false"
                              @onSubmit="onSubmitCreditCard"
        />
    </div>
</template>

<script>
import {mapGetters, mapState, mapActions} from "vuex";

import {reserve, stripeGetClientSecret} from "../../../api/account";

import OptionsCarousel from "../../orders/partials/options/OptionsCarousel";
import ModalErrors from "../../partials/ModalErrors";
import ModalStripePayment from "../../partials/ModalStripePayment";
import IncPaymentMode from "../../cart/partials/IncPaymentMode";

export default {
    name: "ReserveContent",
    inject: {
        privacyModalProvider: {
            from: 'openPrivacyModal',
            default: null
        }
    },
    components: {IncPaymentMode, ModalStripePayment, ModalErrors, OptionsCarousel},
    props: ['peopleNumber', 'days', 'fAcconto', 'acconti', 'privacyCheckboxes', 'paymentModes', 'userInfo'],
    data() {
        return {
            people_number: null,
            day: null,
            time: null,
            reserve_id: null,
            reserve_confirmed: null,
            show_stripe_payment_modal: false,
            stripe_payment_modal_save: false,

            //form,
            name: this.userInfo ? this.userInfo.name : '',
            phone: this.userInfo ? this.userInfo.phone : '',
            email: this.userInfo ? this.userInfo.email : '',
            note: '',
            id_acconto: '',
            privacy_obj: null,

            payment_modes: this.paymentModes,
            payment_mode: null,
            stripe: null
        };
    },
    created() {
        this.people_number = this.people_entries[0].value;
        this.day = this.days[0];
        this.time = this.times_entries[0].value;
        this.privacy_obj = this.getprivacyObj();

        const stripeMode = this.payment_modes.find((mode) => mode.tipo === 'STRIPE_CARTACREDITO');
        if (stripeMode) {
            this.stripe = Stripe(stripeMode.credenziali.publishable_key, {locale: this.language});
        }
    },
    computed: {
        times_carousel: function () {
            if (this.$refs.times_carousel) {
                return this.$refs.times_carousel;
            }

            return null;
        },
        people_entries: function () {
            const peopleEntries = [];
            for (let i = 1; i <= this.peopleNumber; i++) {
                peopleEntries.push({
                    primaryText: i,
                    secondaryText: this.$tc('prenotazioni_tavolo.persona', i).toUpperCase(),
                    value: i,
                });
            }

            return peopleEntries;
        },
        days_entries: function () {
            return this.days.map((giorno) => ({
                primaryText: giorno.week_day,
                secondaryText: giorno.day + ' ' + giorno.month,
                value: giorno,
            }));
        },
        times_entries: function () {
            return this.day.hours.map((ora) => ({
                primaryText: ora.from,
                secondaryText: null,
                value: ora,
            }));
        },
        reserve_object: function () {
            let reserveObject = {
                id: this.reserve_id,
                id_ristorante: this.restaurant_id,
                email: this.user.email,
                api_key: this.user.api_key,
                id_locale: this.locale.id,
                nome: this.name,
                telefono: this.phone,
                email_prenotazione: this.email,
                note: this.note,
                n_persone: this.people_number,
                data_ora_prenotazione: this.day.raw + ' ' + this.time.from + ':00',
                f_privacy: this.privacy_obj.privacy ? 1 : 0,
                dispositivo: 'SITO',
            };

            if (this.id_acconto) {
                reserveObject.modalita_pagamento = this.payment_mode.tipo;
                reserveObject.acconto_prezzo = this.acconti.find(
                    (obj) => obj.id === this.id_acconto,
                ).prezzo;
            }

            return reserveObject;
        },
        ...mapState('global', {
            loading_visible: state => state.loading_visible
        }),
        ...mapState('localization', {
            language: state => state.language
        }),
        ...mapState('restaurant', {
            restaurant_id: state => state.id,
            locale: state => state.locale
        }),
        ...mapState('auth', {
            user: state => state
        }),
        ...mapGetters('restaurant', {
            locale_currency: 'localeCurrency'
        }),
    },
    methods: {
        onPeopleSnapToItem: function (index) {
            this.people_number = this.people_entries[index].value;
        },
        onDaysSnapToItem: function (index) {
            this.day = this.days[index];

            try {
                this.times_carousel.$refs.swiper.$swiper.slideTo(0);
                this.times_carousel.clickSlide(0);
            } catch (e) {
                //Amen
            }
        },
        onTimeSnapToItem: function (index) {
            this.time = this.times_entries[index].value;
        },
        onPrivacyCheck: function (checkbox) {
            this.privacy_obj = Object.assign({}, this.privacy_obj, {
                [checkbox.db_name]:
                    this.privacy_obj[checkbox.db_name] === 1 ? 0 : 1,
            });
        },
        onReserveTap: async function () {
            if (this.id_acconto && !this.payment_mode) {
                this.showModalErrors({
                    title: this.$t('prenotazione').toUpperCase(),
                    errors: [this.$t('nessun_metodo_selezionato')]
                });

                return false;
            } else {
                this.showLoading(true);

                try {
                    const data = await reserve(this.language, this.reserve_object);
                    this.reserve_id = data.id;
                    this.reserve_confirmed = data.f_confermata;

                    this.showLoading(false);

                    switch (this.reserve_object.modalita_pagamento) {
                        case 'STRIPE_CARTACREDITO':
                            if (this.payment_mode.info) {
                                await this.proceedStripePayment(this.payment_mode.info.id, this.payment_mode.saveIt);
                                this.reservationSuccess();
                            } else {
                                this.show_stripe_payment_modal = true;
                            }
                            break;
                        default:
                            this.reservationSuccess();
                            break;
                    }

                    return true;
                } catch ({messages}) {
                    this.showModalErrors({
                        title: this.$t('prenotazione').toUpperCase(),
                        errors: messages
                    });
                    this.showLoading(false);

                    return false;
                }
            }
        },
        proceedStripePayment: function (paymentMethod, savePaymentMethod) {
            return new Promise((resolve, reject) => {
                this.showLoading(true);

                stripeGetClientSecret(this.language, {
                    id_ristorante: this.restaurant_id,
                    api_key: this.user ? this.user.api_key : null,
                    entita_tipo: 'PRENOTAZIONE',
                    entita_id: this.reserve_object.id
                }).then((data) => {
                    this.stripe.confirmCardPayment(data.client_secret, Object.assign({
                        payment_method: paymentMethod
                    }, savePaymentMethod ? {
                        setup_future_usage: 'on_session'
                    } : {})).then((response) => {
                        if (response.paymentIntent) {
                            this.showLoading(false);
                            if (response.paymentIntent.status === 'succeeded') {
                                resolve();
                            } else {
                                this.showModalErrors({
                                    title: this.$t('prenotazione').toUpperCase(),
                                    errors: [this.$t('impossible_confirm_payment')]
                                });
                                reject();
                            }
                        } else if (response.error) {
                            this.showLoading(false);
                            this.showModalErrors({
                                title: this.$t('prenotazione').toUpperCase(),
                                errors: [response.error.message]
                            });
                            reject();
                        }
                    }).catch((e) => {
                        this.showLoading(false);
                        this.showModalErrors({
                            title: this.$t('prenotazione').toUpperCase(),
                            errors: [e.message]
                        });
                        reject();
                    });
                }).catch(({messages}) => {
                    this.showLoading(false);
                    this.showModalErrors({
                        title: this.$t('prenotazione').toUpperCase(),
                        errors: messages
                    });
                    reject();
                });
            });
        },
        reservationSuccess: function (success = true) {
            this.showLoading(false);
            this.$emit('onBooked', success, this.reserve_confirmed);
        },
        openPrivacyModal: function (checkbox) {
            if (this.privacyModalProvider) {
                this.privacyModalProvider(checkbox);
            }
        },
        getprivacyObj: function () {
            const obj = {};
            this.privacyCheckboxes.forEach((privacyCheckbox) => {
                obj[privacyCheckbox.db_name] = false;
            });
            if (this.userInfo && this.userInfo.privacy) obj.privacy = this.userInfo.privacy;

            return obj;
        },
        onHideModalStripePayment: function (success) {
            this.show_stripe_payment_modal = false;
            this.reservationSuccess(success);
        },
        onPaymenModePress: function (item) {
            this.payment_mode = item;
        },
        onCardDeletePress: function (item) {
            const index = this.payment_modes.findIndex((mode) => mode.id === item.id);
            this.payment_modes.splice(index, 1);
            this.payment_mode = null;
        },
        onNewCardPress: function () {
            this.stripe_payment_modal_save = true;
            this.show_stripe_payment_modal = true;
        },
        onSubmitCreditCard: function (card, savePaymentMethod) {

            if (this.stripe_payment_modal_save) {
                this.stripe.createPaymentMethod({
                    type: 'card',
                    card: card
                }).then((result) => {
                    if (result.paymentMethod) {
                        const {card, id} = result.paymentMethod
                        let latestIndexWithCreditCard = null;

                        for (let i = 0; i < this.payment_modes.length; i++) {
                            if (this.payment_modes[i].tipo === 'STRIPE_CARTACREDITO') {
                                latestIndexWithCreditCard = i;
                            }
                        }

                        const spm = {
                            data: {
                                brand: card.brand,
                                expMonth: card.exp_month,
                                expYear: card.exp_year,
                                last4: card.last4,
                            },
                            type: 'card',
                            id: id
                        };

                        const nuovaModalitaPagamento = {
                            id: new Date().getTime(),
                            tipo: 'STRIPE_CARTACREDITO',
                            label: null,
                            credenziali: this.payment_modes[
                                latestIndexWithCreditCard
                                ].credenziali,
                            info: spm,
                            isFresh: true,
                            saveIt: savePaymentMethod,
                        };

                        this.payment_modes.splice(latestIndexWithCreditCard + 1, 0, nuovaModalitaPagamento);
                        this.payment_mode = nuovaModalitaPagamento;

                        this.show_stripe_payment_modal = false;
                        this.stripe_payment_modal_save = false;
                    }
                });
            } else {
                this.proceedStripePayment({card: card}, savePaymentMethod).then(() => {
                    this.reservationSuccess();
                }).finally(() => {
                    this.show_stripe_payment_modal = false;
                    this.stripe_payment_modal_save = false;
                });
            }
        },
        ...mapActions('global', [
            'showLoading',
            'showModalErrors'
        ]),
    }
}
</script>
